import { mainPath } from './config/serverConfig';

import RestMethods from './config/restMethods';

class EventResources {
  constructor() {
    this.restMethods = new RestMethods();
  }

  getEvents(locale) {
      return this.restMethods.get(`${mainPath}/events?locale=${locale}`);
  }
}

export default EventResources;
